import React, { createContext, useContext, useMemo, useState } from 'react'
import { every, get, set } from 'lodash'

const SearchContext = createContext({})

// Apply the given filters; if the target is an array, the filter is run once per element
const applyFilter = (item, filters) => {
  if (!item) return null

  let filteredItem = { ...item }
  const filtersByPath = {}

  Object.keys(filters).forEach((filterKey) => {
    const filter = filters[filterKey]
    if (!filtersByPath[filter.path]) {
      filtersByPath[filter.path] = []
    }
    filtersByPath[filter.path].push(filter.func)
  })

  Object.keys(filtersByPath).forEach((filterPath) => {
    const target = get(filteredItem, filterPath)
    if (Array.isArray(target)) {
      // Use only the filtered array; do not revert to the original target if empty.
      const filtered = target.filter((entry) =>
        every(filtersByPath[filterPath], (filterFunc) => filterFunc(entry))
      )
      set(filteredItem, filterPath, filtered)
    } else if (
      !every(filtersByPath[filterPath], (filterFunc) => filterFunc(target))
    ) {
      filteredItem = null
    }
  })

  return filteredItem
}

export { applyFilter }

export const SearchProvider = ({ children, initialFilters = {} }) => {
  const [filters, setFilters] = useState(initialFilters)
  const [currentMsFilter, setCurrentMsFilter] = useState(null)

  const contextValue = useMemo(
    () => ({
      filters,
      setFilters,
      currentMsFilter,
      setCurrentMsFilter,
      applyFilter,
    }),
    [filters, setFilters, currentMsFilter, setCurrentMsFilter]
  )

  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  )
}

export const useSearchFilters = () => useContext(SearchContext)
